if (!customElements.get('multiblock-section')) {
    class MultiblockSection extends Element {

        setupListeners() {
            this.$el.find('.card-playback').each((_, btn) => {
                const video = btn.parentElement.querySelector('video');
                if (!video) return;

                $(btn).on('click', () => this._togglePlayback(btn, video));

                $(btn).on('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this._togglePlayback(btn, video);
                    }
                });
            });
        }

        _togglePlayback(btn, video) {
            if (video.paused) {
                video.play();
                btn.setAttribute('data-state', 'playing');
                btn.setAttribute('aria-label', 'Pause video');
            } else {
                video.pause();
                btn.setAttribute('data-state', 'paused');
                btn.setAttribute('aria-label', 'Play video');
            }
        }
    }

    customElements.define('multiblock-section', MultiblockSection);
}
